<template>
  <div ref="focusTarget" class="container">
    <h2 class="question-title">{{ step.text }}</h2>
    <div class="question-checkbox">
      <label class="question-checkbox-item" :class="answerClass(option.value)" v-for="(option, i) in step.responses" :key="i" :for="`answer-${i}`" :ref="`answer${option.value}`">
        <input :disabled="answer != null" v-model="answer" class="answer" :id="`answer-${i}`" name="answer" type="radio" :value="option.value" />
        <span>{{ option.text }}</span>
      </label>
    </div>
  </div>
</template>

<script>
import steps from '../../appdata/steps.js'
import StepFunctions from '@/src/components/mixins/StepFunctions.js'

export default {
  mixins: [StepFunctions],
  mounted() {
    var answerIndex = this.answers.map(item => item.id).indexOf(this.stepKey)
    if (answerIndex > -1) {
      this.answer = this.answers[answerIndex].value
    }
  },

  watch: {},
  methods: {
    answerClass(id) {
      if (this.answer === null) {
        return ''
      }
      let answer = this.findAnswer(id)
      let answerPoints = this.answerPoints(id)

      if (this.answer == answer.value) {
        if (answerPoints > 0) {
          return 'correct'
        } else {
          return 'wrong'
        }
      } else {
        if (answerPoints > 0) {
          return 'correct'
        }
      }
    }
  }
}
</script>

<style lang="scss">
input.answer {
  display: none;
  + label {
    padding-left: 0px;
    position: relative;
    border: 2px solid #fff;
    display: block;
    text-align: center;
    cursor: pointer;
    margin: 20px 35px;
    font-size: 19.6px;
    padding: 10px;
    &:hover {
      background: #f04e23;
      border-color: #f04e23;
    }
    @media (max-width: 768px) {
      padding: 10px;
      margin: 14px 10px;
    }
  }
  &:checked + label {
    background: #f04e23;
    border-color: #f04e23;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/steps/Question.vue